<template>
  <table class="mds-data-table series-names-list__table">
    <tbody class="mds-data-table__body">
      <tr
        class="series-list__row mds-data-table__row"
        v-for="(series) in seriesList"
        :key="`series-name-row-${series.id}`"
      >
        <td class="mds-data-table__cell">
          <mds-radio-button
            class="fc-radio-button__series-name"
            name="series-name"
            :value="`${series.id}`"
            :checked="isChecked(series)"
            @input="changeHandler"
          >
            {{ series.seriesName }}
          </mds-radio-button>
        </td>
        <td class="mds-data-table__cell">
          {{ `${getFiduciaryClientName(series.fiduciaryClientId)}` }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState } from 'vuex';
import MdsRadioButton from '@mds/radio-button';

export default {
  name: 'series-list-table',
  components: {
    MdsRadioButton,
  },
  props: {
    selectedSeries: {
      type: Object,
    },
    seriesList: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fiduciaryClients: {},
    };
  },
  computed: {
    ...mapState({
      clientList: (state) => state.grid.clientList,
    }),
  },
  created() {
    this.fiduciaryClients = this.clientList.reduce((obj, item) => ({ ...obj, [item.id]: item.client }), {});
  },
  methods: {
    changeHandler(event) {
      this.$emit('series-checked', Number.parseInt(event, 10));
    },
    isChecked(series) {
      return this.selectedSeries && this.selectedSeries.id === series.id;
    },
    getFiduciaryClientName(fiduciaryClientId) {
      return this.fiduciaryClients[fiduciaryClientId]?.clientName || '-';
    },
  },
};
</script>
<style lang="scss">
.series-names-list__table {
  .mds-data-table__cell {
    padding-top: $mds-space-inset-2-x;
  }
  .mds-data-table__cell {
    padding-bottom: $mds-space-inset-2-x;
  }
  .mds-data-table__row {
    border-bottom: 1px solid $mds-color-neutral-90;
    &:hover {
      @include fc-hover-table-rows();
    }
  }
  .mds-data-table__row .mds-data-table__cell {
    border-top: 0;
  }
  .mds-radio-button__text___connect {
    display: inline-block;
    overflow-wrap: break-word;
    max-width: 1000px;
  }
  .mds-data-table__row .mds-data-table__cell:first-child {
    padding-left: $mds-space-inset-half-x;
  }
}
</style>
